module.exports = __webpack_public_path__ + "img/reimu hakurei lunar war shaman_sc2.03ccd8b5.png";